import { createI18n } from 'vue-i18n';
import en from './en-US';
import cn from './zh-CN';

export const LOCALE_OPTIONS = [
  { label: '简体中文', value: 'zh-CN' },
  { label: 'English', value: 'en-US' },
];
const language = localStorage.getItem('arco-locale');
const defaultLocale = language ? JSON.parse(language) : 'zh-CN';
const i18n = createI18n({
  locale: defaultLocale,
  legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
  globalInjection: true, // 全局生效$t
  messages: {
    'en-US': en,
    'zh-CN': cn,
  },
});

export default i18n;
